import React from 'react'
import { Box } from '@mui/material'

import PredictionForm from '../component/userDirectory/helper/predictionForm'

const Test = () => {
    const testData = {id: '0', file_id: '8f23e185840d4f2da08bd2a2ae07be62', name: 'apple.tiff', created: ''}
    const clear = () => {}

    return (
        <Box className='d-flex justify-content-center align-items-center' sx={{height: '100vh'}}>
        <PredictionForm slideData={testData} closePredictionForm={clear} />
        </Box>
    )
}

export default Test